export default __webpack_public_path__ + "static/media/N2P_1903.9d72fa00.jpg";